import { jsx as _jsx } from "react/jsx-runtime";
import { StyledVideoButton } from "./VideoButton.styles";
// utils
import { makeDataTestIdGetter } from "../../utils";
export const VideoButton = ({ className, disabled, size: sizeString = "standard", dataTestIdPrefix, ariaLabel, onClick, }) => {
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    return (_jsx(StyledVideoButton, { onClick: onClick, symbol: "Play", stylingType: "video", className: className, disabled: disabled, size: sizeString, "data-testid": getDataTestId("video-button-input"), "aria-label": ariaLabel }));
};
